import React, { useState } from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';
import { faPaperclip, faUpload } from '@fortawesome/pro-solid-svg-icons';

import { attachmentExceptionOptions } from './helpers';
import AttachmentsModal from 'bundles/apex/tasks/attachment_modal';
import ClickableIcon from 'components/clickable_icon';
import Tooltip from 'components/tooltip';

export default function AttachmentIcon({
  addTaskAttachment,
  attachmentExceptions,
  attachmentsPath,
  canDeleteAttachments,
  deleteTaskAttachment,
  task,
  onUpdate,
  forUserId
}) {
  if (!task.requiresAttachment) {
    return (
      <div />
    );
  }

  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const onClick = (e) => {
    e.stopPropagation();
    setShowAttachmentsModal(true);
  };

  const attachmentExceptionOption = attachmentExceptionOptions.find(
    option => option.value === task.attachmentException
  );

  let icon;
  if (task.attachments.length > 0) {
    icon = faPaperclip;
  } else if (attachmentExceptions) {
    icon = attachmentExceptionOption.icon;
  } else {
    icon = faUpload;
  }

  let tooltipText;
  if (task.attachments.length > 0) {
    tooltipText = pluralize('attachment', task.attachments.length, true);
  } else if (attachmentExceptions && task.attachmentExceptionReason) {
    tooltipText = task.attachmentExceptionReason;
  }

  const clickableIcon = (
    <div aria-label="attachments">
      <ClickableIcon icon={icon} />
    </div>
  );

  return (
    <div className="task-attachment-icon" onClick={onClick}>
      {tooltipText ? (
        <Tooltip content={tooltipText}>
          {clickableIcon}
        </Tooltip>
      ) : clickableIcon}
      <div onClick={e => e.stopPropagation()}>
        <AttachmentsModal
          addTaskAttachment={attachment => addTaskAttachment(task, attachment)}
          attachmentExceptions={attachmentExceptions}
          attachmentsPath={attachmentsPath}
          canDeleteAttachments={canDeleteAttachments}
          deleteTaskAttachment={attachment => deleteTaskAttachment(task, attachment)}
          forUserId={forUserId}
          show={showAttachmentsModal}
          task={task}
          onHide={() => setShowAttachmentsModal(false)}
          onSave={onUpdate}
        />
      </div>
    </div>
  );
}

AttachmentIcon.propTypes = {
  addTaskAttachment: PropTypes.func.isRequired,
  attachmentExceptions: PropTypes.bool,
  attachmentsPath: PropTypes.string.isRequired,
  canDeleteAttachments: PropTypes.bool.isRequired,
  deleteTaskAttachment: PropTypes.func.isRequired,
  forUserId: PropTypes.number,
  task: PropTypes.shape({
    attachmentException: PropTypes.string,
    attachmentExcpetionReason: PropTypes.string,
    attachments: PropTypes.array.isRequired,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
};
